// @ts-expect-error import.meta n'est pas typable ici : tsconfig est en module commonjs, imposé par
// le ts-node qui exécute server/
const { MODE } = import.meta.env;

export const baseUrl = MODE === 'development' ? 'http://localhost:3080/api' : '/api';

export { googleClientId } from './googleClientId';
